import React, { useState } from "react";
import { Button, Modal, notification } from "antd";

import CustomButton from "../CustomButton";
import phone from "../../assest/preview pic.png";
import template from "../../assest/template.png";

import TemplateDesignes from "./TemplateDesignes";

const CampaignMessagepreview2 = ({ visible, onClose, selectedtemplate ,setSelecteddomain,setSelectedloginTempalte,Selecteddomain,SelectedloginTempalte}) => {
  const cancel = () => {
    if (selectedtemplate?.type === "link" && (!Selecteddomain || !SelectedloginTempalte)) {
      notification.error({
        message: !Selecteddomain ? "Domain is required" : "Login template is required",
        duration: 3,
      }); // ✅ Changed comma to semicolon
      return; // ✅ Added return to prevent onClose() execution in case of an error
    }
    onClose();
  };
  const save = () => {
    
    if (selectedtemplate?.type === "link" && (!Selecteddomain || !SelectedloginTempalte)) {
      notification.error({
        message: !Selecteddomain ? "Domain is required" : "Login template is required",
        duration: 3,
      }); // ✅ Changed comma to semicolon
      return; // ✅ Added return to prevent onClose() execution in case of an error
    }
    setIsModalVisible(false)

    onClose();
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  return (
    <>
      <Modal open={visible} onCancel={onClose} centered footer={[]}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            marginTop: "40px",
          }}
        >
          <div>
          <h2 className="text-xl md:text-3xl">Message Preview</h2>

          </div>
          <div style={{marginTop:"10px",}}>
          <Button
            type="primary"
            shape="round"

            onClick={() => {
              setIsModalVisible(true);
            }}
             >
            Insert Phishing Link
          </Button>
          </div>
 
        </div>
        <p className="mt-3"> {selectedtemplate?.description || ""}</p>
        {(SelectedloginTempalte !== null || Selecteddomain !== null) && (
<div className="flex gap-3 items-center bg-gray-100 rounded-md p-2">
  <img src={template} alt="tem" className="w-16 h-16 rounded-lg"/>
  <div className="space-y-2 w-full">
    <h5 className="font-medium text-[#3A3B3F] text-lg"> {SelectedloginTempalte?.name}</h5>
    <p className="bg-[#ECFDF5] rounded-md px-2 w-fit text-xs text-[#16A34A]"> &bull; {Selecteddomain?.url}</p>
  </div>
</div>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ position: "relative" }}>
          <img className="w-96" alt="" src={phone} style={{height:"550px",}}/>
            <p className="insideshowmessage  max-h-96 overflow-auto">{selectedtemplate?.message}
              <br />
            <span className="text-blue-500 underline underline-offset-2">  {Selecteddomain?.url || "Your Link Here"}</span>
            </p>
          </div>
        </div>

        <CustomButton
          style={{ margin: "auto", display: "flex" }}
          width={"50%"}
          onClick={cancel}
          text={"Continue"}

        />
      </Modal>
      <TemplateDesignes
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSave={ save}
        setSelecteddomain={setSelecteddomain}
        setSelectedloginTempalte={setSelectedloginTempalte}
      />
    </>
  );
};

export default CampaignMessagepreview2;
